import { Component, Output, EventEmitter, Input } from '@angular/core';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { MainTableComponent } from '../main-table.component';
import { TableResponseQuery, XlsxResponseModel } from 'app/core';
import { ImportDialogComponent } from 'app/components/import-dialog/import-dialog.component';

@Component({
    selector: 'pr-promotion-items-table',
    templateUrl: 'promotion-items-table.component.html',
    styleUrls: ['../main-table.component.scss'],
})
export class PromotionItemsTableComponent extends MainTableComponent {
    @Input()
    set innerTable(flag: boolean) {
        if (flag) {
            this.screenHeight = 'calc(100% - 57px)';
        }
    }
    @Output() dataLength = new EventEmitter();
    @Input() isEditMode: boolean;

    @Input() promotionId: Array<number>;

    public importLoading = false;

    loadPage() {
        this.loadSubscription = this.paginator.page
            .pipe(
                startWith({}),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return this.dataService.fetchSelectedPromotionItems(
                        this.pageSize,
                        this.paginator.pageIndex * this.pageSize,
                        this.sortBy,
                        this.filterValue,
                        this.selFilterValue,
                        this.promotionId
                    );
                }),
                map((data: TableResponseQuery) => {
                    this.itemsLength = data.total_count;
                    this.dataLength.emit(data.total_count);
                    this.isLoadingResults = false;
                    return data.items;
                }),
                catchError(() => {
                    this.isLoadingResults = false;
                    return observableOf([]);
                })
            )
            .subscribe((data: any[]) => {
                this.data = data;
            });
    }

    openImportDialog(): void {
        const dialogRef = this.dialog.open(ImportDialogComponent, {
            minWidth: '400px',
            minHeight: '100px',
            data: {
                importConfiguration: 'PromotionItems',
                importApproval: false,
                importFileExt: 'xlsx',
                additionalParams: `promotionId:${this.promotionId}`,
            },
        });
    }

    export(contentType: string) {
        this.importLoading = true;

        if (contentType === 'csv') {
            this.dataService.getCsv(this.promotionId).subscribe(
                (response) => {
                    const blob = new Blob(['\ufeff', response.body], {
                        type: contentType,
                    });
                    const filename = this.generalService.getFilenameFromHeader(
                        response.headers.get('content-disposition')
                    );
                    saveAs(blob, `${filename}.csv`);
                },
                (error) => {
                    this.importLoading = false;
                    if (error.status !== 403) {
                        this.snackBar.info(
                            'Wystąpił błąd podczas zapisywania plik.'
                        );
                    }
                },
                () => (this.importLoading = false)
            );
        }
        if (contentType === 'xlsx') {
            this.dataService.getXlsx(this.promotionId).subscribe(
                (blogResp: XlsxResponseModel) => {
                    this.loadExcel(blogResp);
                },
                (error) => {
                    this.importLoading = false;
                    if (error.status !== 403) {
                        this.snackBar.info(
                            'Wystąpił błąd podczas zapisywania plik.'
                        );
                    }
                },
                () => (this.importLoading = false)
            );
        }
    }

    private loadExcel(resp: XlsxResponseModel) {
        const filename = this.generalService.getFilenameFromHeader(
            resp.titleHeader
        );
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(resp.blob);
        link.download = `${filename}.xlsx`;
        link.click();
    }
}
